import React, {useEffect, useState} from "react";
import axios from "axios";
import {toast} from "react-toastify";

const STRIPE_URL = "https://connect.stripe.com/express/oauth/authorize"
const STRIPE_REDIRECT_URI = `${window.location.origin}/stripe/connect`
function StripeConnectOverview() {
    const [stripeUserId, setStripeUserId] = useState(null);
    const [stripeClientId, setStripeClientId] = useState(null);

    useEffect(() => {
        get_user_id()
    }, []);

    const get_user_id = () => {
        axios.get('/orthoptistes/paiements/stripe/user_id').then((response) => {
            setStripeUserId(response.data.stripe_user_id)
            setStripeClientId(response.data.stripe_client_id)
        }).catch((error) => {
            toast.error("Erreur lors de la récupération des données stripe")
        })
    }

    const disconnect = () => {
        axios.delete('/orthoptistes/paiements/stripe/user_id').then((response) => {
            setStripeUserId(response.data.stripe_user_id)
        }).catch((error) => {
            toast.error("Erreur lors de la déconnexion du compte")
        })
    }

    const stripe_connect_url = `${STRIPE_URL}?redirect_uri=${STRIPE_REDIRECT_URI}&client_id=${stripeClientId}`

    const renderButtons = () => {
        console.log(STRIPE_REDIRECT_URI)
        if(!stripeUserId) return <a className="btn blue darken-2 z-depth-0" href={stripe_connect_url}>
            <i className="material-icons left">account_balance</i>
            Connecter mon compte
        </a>

        return <div className="valign-wrapper" style={{gap: 10}}>
            <a className="btn blue darken-2 z-depth-0" onClick={disconnect}>
                <i className="material-icons left">account_balance</i>
                Déconnecter mon compte
            </a>
        </div>

    }

    return <div className="fc">
        <div className="fr" style={{justifyContent: "space-between"}}>
            <h4 style={{fontWeight: 600, margin: 5}}>Mon compte de tranfert</h4>
            {renderButtons()}
        </div>
        {/*<div className="container center">*/}
        {/*    {renderData()}*/}
        {/*</div>*/}
    </div>
}

export default StripeConnectOverview;